import { Outlet, useLocation } from 'react-router-dom';

import { ErrorBoundary } from './error-boundary';
import { Header } from './header';
import { Sidebar } from './sidebar';

import { PrivacyBanner } from '@/components/privacy/privacy-banner';

const ANALYTICS_ROUTES = new Set(['/', '/engagement', '/compliance', '/outcomes', '/roi', '/reports']);

export function AppShell() {
  const location = useLocation();
  const showPrivacyBanner = ANALYTICS_ROUTES.has(location.pathname);

  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <div className="flex flex-1 flex-col">
        <Header />
        <main className="flex-1 overflow-auto p-4 lg:p-6">
          {showPrivacyBanner && <PrivacyBanner />}
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
    </div>
  );
}
